import React, {Fragment} from 'react'

import {
  EuiBreadcrumbs,
  EuiSpacer
} from '@elastic/eui'


export default function ManualBreadcrumbs() {

  const breadcrumbs = [
    {
      text: 'Über',
      href: '/de/Software/macOS/InstarVision/About/'
    },
    {
      text: 'Erweitert',
      href: '/de/Software/macOS/InstarVision/Advanced/',
    },
    {
      text: 'Kameraliste',
      href: '/de/Software/macOS/InstarVision/Camera_List/'
    },
    {
      text: 'Bildeinstellungen',
      href: '/de/Software/macOS/InstarVision/Image_Adjust/'
    },
    {
      text: 'Layout',
      href: '/de/Software/macOS/InstarVision/Layout/'
    },
    {
      text: 'Kamera PTZ',
      href: '/de/Software/macOS/InstarVision/PTZ/'
    },
    {
      text: 'System',
      href: '/de/Software/macOS/InstarVision/System/'
    },
    {
      text: 'Benutzer',
      href: '/de/Software/macOS/InstarVision/Users/'
    },
    {
      text: '◄ InstarVision',
      href: '/de/Software/macOS/InstarVision/',
    }
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={11}
        aria-label="Software Platform for your INSTAR IP Camera"
      />
      <EuiSpacer />
    </Fragment>
  );
}
